import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { UserLabelPipe } from '@app/features/users/user-label-pipe';
import { UserService } from '@app/features/users/user-service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'userIdToUserName',
  pure: false,
})
export class UserIdToUserNamePipe implements PipeTransform, OnDestroy {
  private userService = inject(UserService);
  private cdr = inject(ChangeDetectorRef);
  private usersMap = new Map<string, string>();
  private sub: Subscription;

  constructor() {
    const userLabelPipe = new UserLabelPipe();
    this.sub = this.userService.allUsers$.subscribe((users) => {
      this.usersMap.clear();
      for (const u of users) {
        this.usersMap.set(u.id, userLabelPipe.transform(u));
      }
      this.cdr.markForCheck();
    });
  }

  transform(userId?: string | null): string | null {
    if (!userId) return null;
    return this.usersMap.get(userId) ?? null;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
